export const RESOURCE_BOOKING = 'RESOURCE_BOOKING';
